import React from 'react';
import PropTypes from 'prop-types';

const OldWalkInListButton = ({ onClick }) => {
  return (
    <button type="button" className="c-btn c-btn--medium c-btn--ghost u-ml-" onClick={onClick}>
      Old Walk-in List
    </button>
  );
};

OldWalkInListButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default OldWalkInListButton;
